export default __webpack_public_path__ + "static/media/logo-papo-antimicrobianos.136f7542.svg";